import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagesService } from '../pages.service';
import { SnippetService } from '../snippet.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
    env = environment;
    pageRoute = '';
    page;
    snippets = [];
    tab = 1;
    snippetSortModal = false;
    snippetAddModal = false;
    isNew = false;
    cols = [
        { Id: 4, name: 'Single tile' },
        { Id: 6, name: 'Double tile' },
        { Id: 12, name: 'Full width' },
    ];
    showImageLibrary = false;
    imageLibraryType = '';
    imageDataField = '';

    tinyInit = {
        selector: '.intro',
        menubar: false,
        inline: true,
        plugins: [
            'preview anchor',
            'searchreplace visualblocks link image imagetools',
        ],
        toolbar:
            'undo redo | formatselect | bold italic | \
            alignleft aligncenter alignright alignjustify | \
            image'
    };


    constructor(
        private pagesService: PagesService,
        private snippetService: SnippetService,
        private router: Router,
        private route: ActivatedRoute,
        private toastrService: ToastrService,
    ) {
        this.pageRoute = this.route.snapshot.params.route;
        if (this.pageRoute !== 'new') {
            this.tab = 2;
            this.getPage();
            this.isNew = false;
        } else {
            this.tab = 1;
            this.isNew = true;
            this.page = {
                active: 1,
                menuId: 0,
                metaDescription: '',
                metaTitle: '',
                name: '',
                introTitle: '',
                introText: '',
                introBackground: '',
                floatingBreadcrumb: 0,
                route: '',
                type: 1,
                qlFooter: 0,
                qlPlugin: 0,
                tile: '',
                tileCols: 4,
                external: 0,
                externalURL: '',
            };
        }
    }

    ngOnInit() {
    }

    setTab(idx) {
        this.tab = idx;
    }

    getPage() {
        this.pagesService.getPage(this.pageRoute).subscribe(data => {
            this.page = data.data;
            this.getSnippets(this.page);
        });
    }

    save() {
        if (this.isNew) {
            this.pagesService.createPage(this.page).subscribe(data => {
                this.pageRoute = data.data.route;
                this.page.route = data.data.route;
                this.isNew = false;
                this.tab = 2;
                this.toastrService.success('Webpage created successfully');
            });
        } else {
            this.pagesService.updatePage(this.page).subscribe(data => {
                this.toastrService.success('Webpage updated successfully');
            });
        }
    }

    getSnippets(page) {
        this.snippetService.getByRoute(page.route).subscribe(data => {
            this.snippets = data.data;
        });
    }

    sortSnippets() {
        this.snippetSortModal = true;
    }

    sortModalAction(e) {
        this.snippetSortModal = false;
        if (e.completed) {
            this.snippets = e.sortation;
            this.toastrService.success('Page contents updated');
        }
    }

    addSnippet() {
        this.snippetAddModal = true;
    }

    addModalAction(e) {
        this.snippetAddModal = false;
        if (e.completed) {
            this.getSnippets(this.page);
            this.toastrService.success('Page contents updated');
        }
    }

    imageSelected(e) {
        if (this.imageDataField === 'pageTile') {
            this.page.tile = e.url;
        }
        if (this.imageDataField === 'pageIntro') {
            this.page.introBackground = e.url;
        }
        this.showImageLibrary = false;
    }

    libraryModalAction(e) {
        this.showImageLibrary = false;
    }


    viewImageLibrary(type, imageDataField) {
        this.imageLibraryType = type;
        this.imageDataField = imageDataField;
        this.showImageLibrary = true;
    }

    deleteTile() {
        this.page.tile = '';
    }

    deleteIntroBackground() {
        this.page.introBackground = '';
    }
}
